import type { ComponentType } from 'react';
import type { OverlaySelectorFunc, OverlayType } from 'ag-grid-community';
import type { CustomOverlayProps } from 'ag-grid-react';

// An overlay gets AG Grid's overlay props plus the grid's `overlayComponentParams` (`TParams`).
type OverlayComponent<TParams> = ComponentType<CustomOverlayProps & TParams>;

type OverlayComponents<TParams> = Partial<Record<OverlayType, { component: OverlayComponent<TParams> }>>;

// An overlay type left out keeps AG Grid's own overlay, whose text comes from the grid's locale text.
export const createOverlayComponentSelector =
  <TParams = object>(overlays: OverlayComponents<TParams>): OverlaySelectorFunc =>
  ({ overlayType }) =>
    overlays[overlayType];

// The grid's empty view for both empty cases: nothing loaded, and a filter that leaves nothing.
export const emptyOverlays = <TParams = object>(component: OverlayComponent<TParams>): OverlayComponents<TParams> => ({
  noRows: { component },
  noMatchingRows: { component },
});
